// extracted by mini-css-extract-plugin
export default {"checkboxLabel":"OrganizationSettings_checkboxLabel__LLKXj"};